import { render, staticRenderFns } from "./SizePicker.vue?vue&type=template&id=0f057e14&"
import script from "./SizePicker.vue?vue&type=script&lang=js&"
export * from "./SizePicker.vue?vue&type=script&lang=js&"
import style0 from "./SizePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports